import { render, staticRenderFns } from "./smsTemplateList.vue?vue&type=template&id=24c34c72"
import script from "./smsTemplateList.vue?vue&type=script&lang=js"
export * from "./smsTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports